import {cloneDeep, findIndex} from "lodash";

export function onGelSubmit(state, payload) {
  let feedbackType = 'FAIL';
  if (checkAllGelHoldersEmpty(state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})].gelTable)) {
    feedbackType = 'SUCCESS';
  }

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})];
  tableData = {...tableData, ...{feedbackType: feedbackType, enableSubmit: false}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onGelReset(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})];
  tableData = {...tableData, ...{feedbackType: null, enableSubmit: false, gelTable: state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})].gelTableBackup}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})] = tableData;

  return {...state, ...{currentSection: {components: currentComponents}}};
}

export function onCloseFeedback(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})];
  tableData = {...tableData, ...{feedbackType: null}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})] = tableData;

  return {...state, ...{currentSection: {components: currentComponents}}};
}

export function onGelUpdate(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})];
  let gelTable = updateGelTable(tableData.gelTable, payload);
  let enableSubmit = true;

  tableData = {...tableData, ...{gelTable: gelTable, enableSubmit: enableSubmit}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onGelSelect(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})];
  let gelTable = updateGelSelection(state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})].gelTable, payload);
  tableData = {...tableData, ...{gelTable: gelTable}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DRAG_DROP_QUESTION"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

function checkAllGelHoldersEmpty(gelTable) {
  return gelTable.reduce((isEmpty, column) => {
    if (isEmpty === true && column.colType === 'BAND_COLUMN') {
      column.colItems.forEach((cell) => {
        if (cell.cellType === 'GEL_HOLDER') {
          isEmpty = cell.cellItems.length === 0;
        }
      });
    }
    return isEmpty;
  }, true);
}

function checkAllDropDownsEmpty(gelTable) {
  return gelTable.reduce((isEmpty, column) => {
    if (isEmpty === true && column.colType === 'BAND_COLUMN') {
      column.colItems.forEach((cell) => {
        if (cell.cellType === 'GEL_PATH') {
          isEmpty = (cell.cellItems.filter((item) => item.selectedOption === null).length === 0)
        }
      });
    }
    return isEmpty;
  }, true);
}

function isCorrect(gelTable) {
  return gelTable.reduce((isInCorrect, column) => {
    if (isInCorrect === true && column.colType === 'BAND_COLUMN') {
      column.colItems.forEach((cell) => {
        if (cell.cellType === 'GEL_PATH') {
          isInCorrect = (cell.cellItems.filter((item) => item.selectedOption.value !== item.correctOptionValue).length === 0)
        }
      });
    }
    return isInCorrect;
  }, true);
}

const getLadderValues = (table) =>
  table[0].colItems[2].cellItems.map((gel) => gel.value).sort((a, b) => a - b);

const getColumnById = (table, colId) =>
  table.find((col) => col.colId === colId);

const getCellById = (column, cellId) =>
  column.colItems.find((cell) => cell.cellId === cellId);

const getGelById = (cell, gelId) =>
  cell.cellItems.find((gel) => gel.gelId === gelId);

const updateGel = (cell, gel, value, ladderValues) => {
  if (cell.cellType === 'GEL_PATH') {
    let ladderLength = ladderValues.length;
    if (value < ladderValues[0]) value = ladderValues[0];
    else if (value > ladderValues[ladderLength - 1])
      value = ladderValues[ladderLength - 1];
    else {
      for (let i = 1; i < ladderLength; i++) {
        if (ladderValues[i - 1] === value) break;
        else if (ladderValues[i] === value) break;
        else if (ladderValues[i - 1] < value && ladderValues[i] > value) {
          const difference = ladderValues[i] - ladderValues[i - 1];
          if (value > ladderValues[i - 1] + difference / 2)
            value = ladderValues[i];
          else value = ladderValues[i - 1];
        } else {
          continue;
        }
      }
    }
    return {...gel, value: value};
  } else {
    return {...gel, value: 0};
  }
};

const removeGelById = (cell, gelId) =>
  cell.cellItems.filter((gel) => gel.gelId !== gelId);

const appendGelToList = (cell, gel) => [...cell.cellItems, gel];

const addCellsToColumn = (cellOne, CellTwo, column) =>
  column.colItems.map((cell) => {
    if (cell.cellId === cellOne.cellId) return cellOne;
    else if (cell.cellId === CellTwo.cellId) return CellTwo;
    else return cell;
  });

const addColumnToTable = (table, column) =>
  table.map((col) => {
    if (col.colId === column.colId) {
      return column;
    }
    return col;
  });

const updateGelItemInList = (currentCell, gelId, gelValue, ladderValues) =>
  currentCell.cellItems.map((gel) => {
    if (gel.gelId === gelId) {
      gel = updateGel(currentCell, gel, gelValue, ladderValues);
    }
    return gel;
  });

export function updateGelTable(gelTable, payload) {
  const ladderValues = getLadderValues(gelTable);
  const column = getColumnById(gelTable, payload.colId);
  if (column) {
    const currentCell = getCellById(column, payload.currentCellId);
    if (payload.prevCellId === payload.currentCellId) {
      currentCell.cellItems = updateGelItemInList(
        currentCell,
        payload.gelId,
        payload.value,
        ladderValues
      );
    } else {
      const previousCell = getCellById(column, payload.prevCellId);
      let gelItem = getGelById(previousCell, payload.gelId);
      gelItem = updateGel(currentCell, gelItem, payload.value, ladderValues);
      previousCell.cellItems = removeGelById(previousCell, payload.gelId);
      currentCell.cellItems = appendGelToList(currentCell, gelItem);
      column.colItems = addCellsToColumn(currentCell, previousCell, column);
    }
    gelTable = addColumnToTable(gelTable, column);
  }
  return updateGelSelection(gelTable, {
    colId: payload.colId,
    cellId: payload.currentCellId,
    gelId: payload.gelId,
  });
}

export function updateGelTableDropDown(gelTable, payload) {

  const column = getColumnById(gelTable, payload.colId);
  if (column) {

    const currentCell = getCellById(column, payload.currentCellId);
    const previousCell = getCellById(column, payload.prevCellId);

    let gelItem = getGelById(previousCell, payload.gelId);
    gelItem.selectedOption = {value: payload.value, label:payload.label};
    column.colItems = addCellsToColumn(currentCell, previousCell, column);

    gelTable = addColumnToTable(gelTable, column);
  }
  return updateGelSelection(gelTable, {
    colId: payload.colId,
    cellId: payload.currentCellId,
    gelId: payload.gelId,
  });
}

export function updateGelSelection(gelTable, params) {
  return gelTable.map((column) => {
    if (column.colId === params.colId) {
      column.colItems = column.colItems.map((cell) => {
        if (cell.cellId === params.cellId) {
          cell.cellItems = cell.cellItems.map((gel) => {
            if (gel.gelId === params.gelId) {
              gel = {...gel, selected: true};
            } else {
              gel = {...gel, selected: false};
            }
            return gel;
          });
        } else {
          if (cell.cellItems) {
            cell.cellItems = cell.cellItems.map((gel) => ({
              ...gel,
              selected: false,
            }));
          }
        }
        return cell;
      });
    } else {
      if (column.colItems) {
        column.colItems = column.colItems.map((cell) => {
          if (cell.cellItems) {
            cell.cellItems = cell.cellItems.map((gel) => ({
              ...gel,
              selected: false,
            }));
          }
          return cell;
        });
      }
    }
    return column;
  });
}

// New redux reducers for the drop down questions
export function onDropDownSubmit(state, payload) {
  console.log('submited gel drop drown');
  console.log({payload});
  console.log('end of submited gel drop drown');
  let feedbackType = 'INCOMPLETE';
  const getTable = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})].gelTable
  if (checkAllDropDownsEmpty(getTable)) {
    if(isCorrect(getTable)){
      feedbackType = 'CORRECT'
    }else{
      feedbackType = 'INCORRECT';
    }
    
  }

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})];
  tableData = {...tableData, ...{feedbackType: feedbackType, enableSubmit: false}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onDropDownReset(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})];
  let gelTable = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})].gelTableBackup
  tableData = {...tableData, ...{feedbackType: null, enableSubmit: false, gelTable } };
  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onDropDownCloseFeedback(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})];
  tableData = {...tableData, ...{feedbackType: null}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onDropDownUpdate(state, payload) {


  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})];
  let gelTable = updateGelTableDropDown(tableData.gelTable, payload);
  let enableSubmit = true;

  tableData = {...tableData, ...{gelTable: gelTable, enableSubmit: enableSubmit}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}

export function onDropDownSelect(state, payload) {

  let tableData = state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})];
  let gelTable = updateGelSelection(state.currentSection.components[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})].gelTable, payload);
  tableData = {...tableData, ...{gelTable: gelTable}};

  let currentComponents = cloneDeep(state.currentSection.components);
  currentComponents[findIndex(state.currentSection.components, {type: "GEL_DROP_DOWN"})] = tableData;

  return {...state, ...{currentSection: {title: state.currentSection.title, components: currentComponents}}};
}
